import { ButtonVariants } from './types/ButtonVariants';

export type ButtonColorFamily = 'yellow' | 'white' | 'black';

// The dominant color each Button variant renders in. Exhaustive over ButtonVariants, so adding a
// new variant is a compile error here until it is classified.
const COLOR_FAMILY_BY_VARIANT: Record<ButtonVariants, ButtonColorFamily> = {
  primary: 'yellow',
  yellowBlackBorder: 'yellow',
  secondary: 'white',
  quinary: 'white',
  quaternary: 'white',
  whiteBlackBorder: 'white',
  destructive: 'white',
  secondaryBlack: 'black',
  tertiary: 'black',
  black: 'black',
};

/**
 * The color family a Button variant belongs to. Falls back to `yellow` for a missing/unknown
 * variant, matching Button's own default variant (`primary`).
 */
export function getButtonColorFamily(variant?: string): ButtonColorFamily {
  return COLOR_FAMILY_BY_VARIANT[(variant ?? '') as ButtonVariants] ?? 'yellow';
}
